import { INPUT } from "../../constants/components";

export const configuration = {
  select: {
    search: {
      minLength: INPUT.SELECT.SEARCH.MIN_LENGTH,
      debounceTime: INPUT.SELECT.SEARCH.DEBOUNCE_TIME,
    },
  },
};
